const template=`
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax momentumMax">
    <div class="maxWidgetsContainer">
      <widget-status></widget-status>
      <div>
        <h3 class="widgetNoResultsLabel translate" ng-show="noContent &amp;&amp; !widgetIsLoading">No results</h3>
      </div>
      <div data-ng-hide="widgetIsLoading || serviceError || noContent || notConfigured">
        <momentum-d3 class="bubble" data="chartData" chart-type="graphType" selected="selectedNodes" drill="drill(id, change, type)" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></momentum-d3>
      </div>
      <div class="chartToggle hide-print" ng-hide="widgetIsLoading || serviceError || noContent || notConfigured">
        <div class="switchButton translate" ng-repeat="enrichment in widget.availableEnrichmentTypes" ng-class="{active: enrichmentType == enrichment.id}" ng-click="toggleEnrichment(enrichment.id)" translate="translate">{{enrichment.name}}</div>
      </div>
    </div>
    <div class="clearFix" style="height:45px;"></div>
    <widget-content-stream-maximized widget="widget" is-loading="widgetIsLoading" update-content-stream-query="updateContentStreamQuery" ng-if="widget.hasRequiredSettings()"></widget-content-stream-maximized>
  </div>
</div>`;
export default template;
